import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as CreateDomainGenericError } from "./types/CreateDomain/CreateDomainError";
import { InvalidParameterError as CreateDomainInvalidParameterError } from "./types/CreateDomain/CreateDomainError";
import { UnauthorizedError as CreateDomainUnauthorizedError } from "./types/CreateDomain/CreateDomainError";
import { InvalidSubscriptionError as CreateDomainInvalidSubscriptionError } from "./types/CreateDomain/CreateDomainError";
import { ForbiddenError as CreateDomainForbiddenError } from "./types/CreateDomain/CreateDomainError";
import { DomainAlreadyExistError as CreateDomainDomainAlreadyExistError } from "./types/CreateDomain/CreateDomainError";
import { InternalServerError as CreateDomainInternalServerError } from "./types/CreateDomain/CreateDomainError";
import { BadGatewayError as CreateDomainBadGatewayError } from "./types/CreateDomain/CreateDomainError";
import { GatewayTimeoutError as CreateDomainGatewayTimeoutError } from "./types/CreateDomain/CreateDomainError";
import { GenericError as DeleteDomainGenericError } from "./types/DeleteDomain/DeleteDomainError";
import { InvalidParameterError as DeleteDomainInvalidParameterError } from "./types/DeleteDomain/DeleteDomainError";
import { UnauthorizedError as DeleteDomainUnauthorizedError } from "./types/DeleteDomain/DeleteDomainError";
import { DomainIsCNameError as DeleteDomainDomainIsCNameError } from "./types/DeleteDomain/DeleteDomainError";
import { ForbiddenError as DeleteDomainForbiddenError } from "./types/DeleteDomain/DeleteDomainError";
import { NotFoundError as DeleteDomainNotFoundError } from "./types/DeleteDomain/DeleteDomainError";
import { InternalServerError as DeleteDomainInternalServerError } from "./types/DeleteDomain/DeleteDomainError";
import { BadGatewayError as DeleteDomainBadGatewayError } from "./types/DeleteDomain/DeleteDomainError";
import { GatewayTimeoutError as DeleteDomainGatewayTimeoutError } from "./types/DeleteDomain/DeleteDomainError";
import { GenericError as DeleteDomainCustomizationGenericError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { InvalidParameterError as DeleteDomainCustomizationInvalidParameterError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { UnauthorizedError as DeleteDomainCustomizationUnauthorizedError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { ForbiddenError as DeleteDomainCustomizationForbiddenError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { NotFoundError as DeleteDomainCustomizationNotFoundError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { InternalServerError as DeleteDomainCustomizationInternalServerError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { BadGatewayError as DeleteDomainCustomizationBadGatewayError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { GatewayTimeoutError as DeleteDomainCustomizationGatewayTimeoutError } from "./types/DeleteDomainCustomization/DeleteDomainCustomizationError";
import { GenericError as GetDomainGenericError } from "./types/GetDomain/GetDomainError";
import { InvalidParameterError as GetDomainInvalidParameterError } from "./types/GetDomain/GetDomainError";
import { UnauthorizedError as GetDomainUnauthorizedError } from "./types/GetDomain/GetDomainError";
import { ForbiddenError as GetDomainForbiddenError } from "./types/GetDomain/GetDomainError";
import { NotFoundError as GetDomainNotFoundError } from "./types/GetDomain/GetDomainError";
import { InternalServerError as GetDomainInternalServerError } from "./types/GetDomain/GetDomainError";
import { BadGatewayError as GetDomainBadGatewayError } from "./types/GetDomain/GetDomainError";
import { GatewayTimeoutError as GetDomainGatewayTimeoutError } from "./types/GetDomain/GetDomainError";
import { GenericError as GetDomainCustomizationGenericError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { InvalidParameterError as GetDomainCustomizationInvalidParameterError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { UnauthorizedError as GetDomainCustomizationUnauthorizedError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { ForbiddenError as GetDomainCustomizationForbiddenError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { NotFoundError as GetDomainCustomizationNotFoundError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { InternalServerError as GetDomainCustomizationInternalServerError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { BadGatewayError as GetDomainCustomizationBadGatewayError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { GatewayTimeoutError as GetDomainCustomizationGatewayTimeoutError } from "./types/GetDomainCustomization/GetDomainCustomizationError";
import { GenericError as GetRecordGenericError } from "./types/GetRecord/GetRecordError";
import { InvalidParameterError as GetRecordInvalidParameterError } from "./types/GetRecord/GetRecordError";
import { NotFoundError as GetRecordNotFoundError } from "./types/GetRecord/GetRecordError";
import { InternalServerError as GetRecordInternalServerError } from "./types/GetRecord/GetRecordError";
import { BadGatewayError as GetRecordBadGatewayError } from "./types/GetRecord/GetRecordError";
import { GatewayTimeoutError as GetRecordGatewayTimeoutError } from "./types/GetRecord/GetRecordError";
import { GenericError as ListDomainsGenericError } from "./types/ListDomains/ListDomainsError";
import { UnauthorizedError as ListDomainsUnauthorizedError } from "./types/ListDomains/ListDomainsError";
import { ForbiddenError as ListDomainsForbiddenError } from "./types/ListDomains/ListDomainsError";
import { InternalServerError as ListDomainsInternalServerError } from "./types/ListDomains/ListDomainsError";
import { BadGatewayError as ListDomainsBadGatewayError } from "./types/ListDomains/ListDomainsError";
import { GatewayTimeoutError as ListDomainsGatewayTimeoutError } from "./types/ListDomains/ListDomainsError";
import { GenericError as ListRecordProvidersGenericError } from "./types/ListRecordProviders/ListRecordProvidersError";
import { InvalidParameterError as ListRecordProvidersInvalidParameterError } from "./types/ListRecordProviders/ListRecordProvidersError";
import { NotFoundError as ListRecordProvidersNotFoundError } from "./types/ListRecordProviders/ListRecordProvidersError";
import { InternalServerError as ListRecordProvidersInternalServerError } from "./types/ListRecordProviders/ListRecordProvidersError";
import { BadGatewayError as ListRecordProvidersBadGatewayError } from "./types/ListRecordProviders/ListRecordProvidersError";
import { GatewayTimeoutError as ListRecordProvidersGatewayTimeoutError } from "./types/ListRecordProviders/ListRecordProvidersError";
import { GenericError as UpdateDomainGenericError } from "./types/UpdateDomain/UpdateDomainError";
import { InvalidParameterError as UpdateDomainInvalidParameterError } from "./types/UpdateDomain/UpdateDomainError";
import { UnauthorizedError as UpdateDomainUnauthorizedError } from "./types/UpdateDomain/UpdateDomainError";
import { InvalidSubscriptionError as UpdateDomainInvalidSubscriptionError } from "./types/UpdateDomain/UpdateDomainError";
import { DomainIsCNameError as UpdateDomainDomainIsCNameError } from "./types/UpdateDomain/UpdateDomainError";
import { ForbiddenError as UpdateDomainForbiddenError } from "./types/UpdateDomain/UpdateDomainError";
import { NotFoundError as UpdateDomainNotFoundError } from "./types/UpdateDomain/UpdateDomainError";
import { DomainAlreadyExistError as UpdateDomainDomainAlreadyExistError } from "./types/UpdateDomain/UpdateDomainError";
import { InternalServerError as UpdateDomainInternalServerError } from "./types/UpdateDomain/UpdateDomainError";
import { BadGatewayError as UpdateDomainBadGatewayError } from "./types/UpdateDomain/UpdateDomainError";
import { GatewayTimeoutError as UpdateDomainGatewayTimeoutError } from "./types/UpdateDomain/UpdateDomainError";
import { GenericError as UpdateDomainCustomizationGenericError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
import { InvalidParameterError as UpdateDomainCustomizationInvalidParameterError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
import { UnauthorizedError as UpdateDomainCustomizationUnauthorizedError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
import { ForbiddenError as UpdateDomainCustomizationForbiddenError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
import { NotFoundError as UpdateDomainCustomizationNotFoundError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
import { InternalServerError as UpdateDomainCustomizationInternalServerError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
import { BadGatewayError as UpdateDomainCustomizationBadGatewayError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
import { GatewayTimeoutError as UpdateDomainCustomizationGatewayTimeoutError } from "./types/UpdateDomainCustomization/UpdateDomainCustomizationError";
export const errors = {
    CreateDomain: {
        InvalidParameterError: CreateDomainInvalidParameterError,
        UnauthorizedError: CreateDomainUnauthorizedError,
        InvalidSubscriptionError: CreateDomainInvalidSubscriptionError,
        ForbiddenError: CreateDomainForbiddenError,
        DomainAlreadyExistError: CreateDomainDomainAlreadyExistError,
        InternalServerError: CreateDomainInternalServerError,
        BadGatewayError: CreateDomainBadGatewayError,
        GatewayTimeoutError: CreateDomainGatewayTimeoutError,
        GenericError: CreateDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteDomain: {
        InvalidParameterError: DeleteDomainInvalidParameterError,
        UnauthorizedError: DeleteDomainUnauthorizedError,
        DomainIsCNameError: DeleteDomainDomainIsCNameError,
        ForbiddenError: DeleteDomainForbiddenError,
        NotFoundError: DeleteDomainNotFoundError,
        InternalServerError: DeleteDomainInternalServerError,
        BadGatewayError: DeleteDomainBadGatewayError,
        GatewayTimeoutError: DeleteDomainGatewayTimeoutError,
        GenericError: DeleteDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteDomainCustomization: {
        InvalidParameterError: DeleteDomainCustomizationInvalidParameterError,
        UnauthorizedError: DeleteDomainCustomizationUnauthorizedError,
        ForbiddenError: DeleteDomainCustomizationForbiddenError,
        NotFoundError: DeleteDomainCustomizationNotFoundError,
        InternalServerError: DeleteDomainCustomizationInternalServerError,
        BadGatewayError: DeleteDomainCustomizationBadGatewayError,
        GatewayTimeoutError: DeleteDomainCustomizationGatewayTimeoutError,
        GenericError: DeleteDomainCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDomain: {
        InvalidParameterError: GetDomainInvalidParameterError,
        UnauthorizedError: GetDomainUnauthorizedError,
        ForbiddenError: GetDomainForbiddenError,
        NotFoundError: GetDomainNotFoundError,
        InternalServerError: GetDomainInternalServerError,
        BadGatewayError: GetDomainBadGatewayError,
        GatewayTimeoutError: GetDomainGatewayTimeoutError,
        GenericError: GetDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDomainCustomization: {
        InvalidParameterError: GetDomainCustomizationInvalidParameterError,
        UnauthorizedError: GetDomainCustomizationUnauthorizedError,
        ForbiddenError: GetDomainCustomizationForbiddenError,
        NotFoundError: GetDomainCustomizationNotFoundError,
        InternalServerError: GetDomainCustomizationInternalServerError,
        BadGatewayError: GetDomainCustomizationBadGatewayError,
        GatewayTimeoutError: GetDomainCustomizationGatewayTimeoutError,
        GenericError: GetDomainCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetRecord: {
        InvalidParameterError: GetRecordInvalidParameterError,
        NotFoundError: GetRecordNotFoundError,
        InternalServerError: GetRecordInternalServerError,
        BadGatewayError: GetRecordBadGatewayError,
        GatewayTimeoutError: GetRecordGatewayTimeoutError,
        GenericError: GetRecordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDomains: {
        UnauthorizedError: ListDomainsUnauthorizedError,
        ForbiddenError: ListDomainsForbiddenError,
        InternalServerError: ListDomainsInternalServerError,
        BadGatewayError: ListDomainsBadGatewayError,
        GatewayTimeoutError: ListDomainsGatewayTimeoutError,
        GenericError: ListDomainsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListRecordProviders: {
        InvalidParameterError: ListRecordProvidersInvalidParameterError,
        NotFoundError: ListRecordProvidersNotFoundError,
        InternalServerError: ListRecordProvidersInternalServerError,
        BadGatewayError: ListRecordProvidersBadGatewayError,
        GatewayTimeoutError: ListRecordProvidersGatewayTimeoutError,
        GenericError: ListRecordProvidersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateDomain: {
        InvalidParameterError: UpdateDomainInvalidParameterError,
        UnauthorizedError: UpdateDomainUnauthorizedError,
        InvalidSubscriptionError: UpdateDomainInvalidSubscriptionError,
        DomainIsCNameError: UpdateDomainDomainIsCNameError,
        ForbiddenError: UpdateDomainForbiddenError,
        NotFoundError: UpdateDomainNotFoundError,
        DomainAlreadyExistError: UpdateDomainDomainAlreadyExistError,
        InternalServerError: UpdateDomainInternalServerError,
        BadGatewayError: UpdateDomainBadGatewayError,
        GatewayTimeoutError: UpdateDomainGatewayTimeoutError,
        GenericError: UpdateDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateDomainCustomization: {
        InvalidParameterError: UpdateDomainCustomizationInvalidParameterError,
        UnauthorizedError: UpdateDomainCustomizationUnauthorizedError,
        ForbiddenError: UpdateDomainCustomizationForbiddenError,
        NotFoundError: UpdateDomainCustomizationNotFoundError,
        InternalServerError: UpdateDomainCustomizationInternalServerError,
        BadGatewayError: UpdateDomainCustomizationBadGatewayError,
        GatewayTimeoutError: UpdateDomainCustomizationGatewayTimeoutError,
        GenericError: UpdateDomainCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateDomainError: {
        InvalidParameterError: CreateDomainInvalidParameterError,
        UnauthorizedError: CreateDomainUnauthorizedError,
        InvalidSubscriptionError: CreateDomainInvalidSubscriptionError,
        ForbiddenError: CreateDomainForbiddenError,
        DomainAlreadyExistError: CreateDomainDomainAlreadyExistError,
        InternalServerError: CreateDomainInternalServerError,
        BadGatewayError: CreateDomainBadGatewayError,
        GatewayTimeoutError: CreateDomainGatewayTimeoutError,
        GenericError: CreateDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteDomainError: {
        InvalidParameterError: DeleteDomainInvalidParameterError,
        UnauthorizedError: DeleteDomainUnauthorizedError,
        DomainIsCNameError: DeleteDomainDomainIsCNameError,
        ForbiddenError: DeleteDomainForbiddenError,
        NotFoundError: DeleteDomainNotFoundError,
        InternalServerError: DeleteDomainInternalServerError,
        BadGatewayError: DeleteDomainBadGatewayError,
        GatewayTimeoutError: DeleteDomainGatewayTimeoutError,
        GenericError: DeleteDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteDomainCustomizationError: {
        InvalidParameterError: DeleteDomainCustomizationInvalidParameterError,
        UnauthorizedError: DeleteDomainCustomizationUnauthorizedError,
        ForbiddenError: DeleteDomainCustomizationForbiddenError,
        NotFoundError: DeleteDomainCustomizationNotFoundError,
        InternalServerError: DeleteDomainCustomizationInternalServerError,
        BadGatewayError: DeleteDomainCustomizationBadGatewayError,
        GatewayTimeoutError: DeleteDomainCustomizationGatewayTimeoutError,
        GenericError: DeleteDomainCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDomainError: {
        InvalidParameterError: GetDomainInvalidParameterError,
        UnauthorizedError: GetDomainUnauthorizedError,
        ForbiddenError: GetDomainForbiddenError,
        NotFoundError: GetDomainNotFoundError,
        InternalServerError: GetDomainInternalServerError,
        BadGatewayError: GetDomainBadGatewayError,
        GatewayTimeoutError: GetDomainGatewayTimeoutError,
        GenericError: GetDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDomainCustomizationError: {
        InvalidParameterError: GetDomainCustomizationInvalidParameterError,
        UnauthorizedError: GetDomainCustomizationUnauthorizedError,
        ForbiddenError: GetDomainCustomizationForbiddenError,
        NotFoundError: GetDomainCustomizationNotFoundError,
        InternalServerError: GetDomainCustomizationInternalServerError,
        BadGatewayError: GetDomainCustomizationBadGatewayError,
        GatewayTimeoutError: GetDomainCustomizationGatewayTimeoutError,
        GenericError: GetDomainCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetRecordError: {
        InvalidParameterError: GetRecordInvalidParameterError,
        NotFoundError: GetRecordNotFoundError,
        InternalServerError: GetRecordInternalServerError,
        BadGatewayError: GetRecordBadGatewayError,
        GatewayTimeoutError: GetRecordGatewayTimeoutError,
        GenericError: GetRecordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDomainsError: {
        UnauthorizedError: ListDomainsUnauthorizedError,
        ForbiddenError: ListDomainsForbiddenError,
        InternalServerError: ListDomainsInternalServerError,
        BadGatewayError: ListDomainsBadGatewayError,
        GatewayTimeoutError: ListDomainsGatewayTimeoutError,
        GenericError: ListDomainsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListRecordProvidersError: {
        InvalidParameterError: ListRecordProvidersInvalidParameterError,
        NotFoundError: ListRecordProvidersNotFoundError,
        InternalServerError: ListRecordProvidersInternalServerError,
        BadGatewayError: ListRecordProvidersBadGatewayError,
        GatewayTimeoutError: ListRecordProvidersGatewayTimeoutError,
        GenericError: ListRecordProvidersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateDomainError: {
        InvalidParameterError: UpdateDomainInvalidParameterError,
        UnauthorizedError: UpdateDomainUnauthorizedError,
        InvalidSubscriptionError: UpdateDomainInvalidSubscriptionError,
        DomainIsCNameError: UpdateDomainDomainIsCNameError,
        ForbiddenError: UpdateDomainForbiddenError,
        NotFoundError: UpdateDomainNotFoundError,
        DomainAlreadyExistError: UpdateDomainDomainAlreadyExistError,
        InternalServerError: UpdateDomainInternalServerError,
        BadGatewayError: UpdateDomainBadGatewayError,
        GatewayTimeoutError: UpdateDomainGatewayTimeoutError,
        GenericError: UpdateDomainGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateDomainCustomizationError: {
        InvalidParameterError: UpdateDomainCustomizationInvalidParameterError,
        UnauthorizedError: UpdateDomainCustomizationUnauthorizedError,
        ForbiddenError: UpdateDomainCustomizationForbiddenError,
        NotFoundError: UpdateDomainCustomizationNotFoundError,
        InternalServerError: UpdateDomainCustomizationInternalServerError,
        BadGatewayError: UpdateDomainCustomizationBadGatewayError,
        GatewayTimeoutError: UpdateDomainCustomizationGatewayTimeoutError,
        GenericError: UpdateDomainCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
